module.exports = __webpack_public_path__ + "static/media/go-big-go-home-large-cta.a0efd8b1.webp";